import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AddItemButtonProps {
  label: string;
  onClick?: () => void;
  className?: string;
}

/**
 * Canonical "add another item" control used across form sections (alternate phone,
 * address, custom field…): a charcoal (text-primary) text link with a `+` icon — no
 * border, no bar. Charcoal (not brand-blue) keeps it a quiet, repeated secondary action,
 * matching "Edit fields"/"Done"; brand-blue stays reserved for the finder/CTA.
 */
export function AddItemButton({ label, onClick, className }: AddItemButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline',
        className,
      )}
    >
      <Plus className="size-3.5" />
      {label}
    </button>
  );
}
